import React, { useState, useEffect } from"react";
import { useNavigate } from"react-router-dom";
import Editor from"@monaco-editor/react";
import axios from"axios";
import API_BASE_URL from"../Config/config";

const HuntLevel1 = () => {
 const [code, setCode] = useState("");
 const [output, setOutput] = useState("");
 const [startTime] = useState(Date.now());
 const [elapsedTime, setElapsedTime] = useState(0);
 const [showClue, setShowClue] = useState(false);

 const navigate = useNavigate();

 useEffect(() => {
 const timer = setInterval(() => {
 setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
 }, 1000);
 return () => clearInterval(timer);
 }, [startTime]);

 const handleSubmit = async () => {
 try {
 const response = await axios.post(`${API_BASE_URL}/api/hunt/submit/1`, { code });
 if (response.data.success) {
 setOutput(response.data.message);
 setShowClue(true);
 } else {
 setOutput(response.data.message);
 }
 } catch (err) {
 setOutput("Error connecting to the server.");
 }
 };

 return (
 <div className="min-h-screen bg-bgMain text-gold p-8 relative">
 <h1 className="text-3xl font-bold mb-4">Level 1: The Ciphered Letter</h1>
 <p className="mb-6 text-white">
 The output of this Python code will help you find your first clue.
 </p>

 <div className="bg-[#1a1a1a] text-white text-sm font-mono p-4 rounded-md overflow-x-auto mb-6 border border-primary shadow-lg">
 <pre>
{`def caesar_decrypt(text, shift=3):
 result = ''
 for char in text:
 if char.isupper():
 result += chr((ord(char) - shift - 65) % 26 + 65)
 elif char.islower():
 result += chr((ord(char) - shift - 97) % 26 + 97)
 else:
 result += char
 return result

message = 'Wklv lv d whvw phvvdjh'
print(caesar_decrypt(message))`}
 </pre>
 </div>

 <div className="mb-2 text-sm text-muted">⏱ Time Elapsed: {elapsedTime}s</div>

 <div className="bg-[#1e1e1e] rounded-md mb-4">
 <Editor
 height="300px"
 defaultLanguage="plaintext"
 theme="vs-dark"
 value={code}
 onChange={(value) => setCode(value)}
 />
 </div>

 <button
 onClick={handleSubmit}
 className="mt-4 bg-primary text-white px-6 py-2 rounded-md hover:bg-secondary transition"
 >
 Submit
 </button>

 <div className="mt-4 bg-[#111] p-4 rounded-md">
 <h3 className="text-white font-semibold">Output:</h3>
 <pre className="text-green-400 whitespace-pre-wrap">{output}</pre>
 </div>

 {/* 🔍 Fullscreen Clue Poster */}
 {showClue && (
 <div className="fixed inset-0 bg-bgMain bg-opacity-90 flex flex-col items-center justify-center z-50 animate-fade-in px-4">
 <h2 className="text-2xl font-bold text-white mb-4">🔍 Clue Unlocked</h2>
 <img
 src="/clue1.png"
 alt="Clue 1"
 className="max-h-[85vh] w-auto border-4 border-secondary rounded-lg shadow-2xl transition-transform duration-500"
 />
 <button
 onClick={() => navigate("/level2")}
 className="mt-6 bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition"
 >
 Proceed to Level 2
 </button>
 </div>
 )}
 </div>
 );
};

export default HuntLevel1;



